
function formatNumberString(input) {
  // Convert the input to a string if it's a number
  const str = typeof input === "number" ? String(input) : input;

  // Check if the string contains a period
  if (str.includes(".")) {
    const [integerPart, decimalPart] = str.split(".");

    // Add a "0" at the end if there's only one number after the period
    if (decimalPart.length === 1) {
      return `${integerPart},${decimalPart}0`;
    } else {
      return str.replace(".", ",");
    }
  }

  return str;
}

const Helpers = {
  formatNumberString,
};
export default Helpers;